export default "__VITE_ASSET__4625e1a0__"